var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.189941,
    width: 38,
    height: 38,
    rx: 8,
    fill: "#2D2D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2346 12.6861C27.6666 11.4911 26.5086 10.3331 25.3136 10.7661L10.7086 16.0481C9.50955 16.4821 9.36455 18.1181 10.4676 18.7571L15.1296 21.4561L19.2926 17.2931C19.4812 17.1109 19.7338 17.0101 19.996 17.0124C20.2582 17.0147 20.509 17.1199 20.6944 17.3053C20.8798 17.4907 20.9849 17.7415 20.9872 18.0037C20.9895 18.2659 20.8887 18.5185 20.7066 18.7071L16.5436 22.8701L19.2436 27.5321C19.8816 28.6351 21.5176 28.4891 21.9516 27.2911L27.2346 12.6861Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrap);
export default __webpack_public_path__ + "static/media/wrap.6a2c40f81d87971587553be18fca0a06.svg";
export { ForwardRef as ReactComponent };